import React from "react";
import OngoingRa from "../../../../../Components/ReverseAuction/OngoingRa/OngoingRa";

const TenderOngoing = () => {
  return <OngoingRa type={"RA_ONGOING"} />;
};

export default TenderOngoing;
